/* global DataTable */

$(() => {
  $.extend(true, DataTable.defaults, {
    deferRender: true,
    processing: true,
    scrollX: true,
  });
});
